import useMousePosition from 'hooks/mouseMove';
import React, { useRef, useState } from 'react';
import { RiskMapDataType2 } from '../types';
import Popup from './Popup';

type RiskTileProps = {
  riskRatedFunds: RiskMapDataType2[];
  timeHorizon: string;
};

const RiskTile: React.FC<RiskTileProps> = ({ riskRatedFunds, timeHorizon }) => {
  const mouseLocation = useMousePosition();
  const [hovering, setHovering] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(0);
  const [style, setStyle] = useState({});
  const tileRef = useRef<any>(null);
  const foundResults =
    Array.isArray(riskRatedFunds) && riskRatedFunds.length !== 0;
  const isNotFound = !foundResults;
  const isCombination =
    !!riskRatedFunds[0] && riskRatedFunds[0].allocation !== 1;

  const createPositionedStyle = (
    left: number,
    right: number,
    top: number,
    bottom: number,
    isLeftAligned: boolean,
    isTopAligned: boolean
  ) => {
    if (isLeftAligned && isTopAligned) {
      setStyle({ ...{ left: right, top } });
    }
    if (!isLeftAligned && isTopAligned) {
      setStyle({ ...{ right: window.innerWidth - left, top } });
    }
    if (isLeftAligned && !isTopAligned) {
      setStyle({ ...{ left: right, bottom: window.innerHeight - bottom } });
    }
    if (!isLeftAligned && !isTopAligned) {
      setStyle({
        ...{
          right: window.innerWidth - left,
          bottom: window.innerHeight - bottom
        }
      });
    }
  };

  const debouncedMouseEnter = (e: any, index: number) => {
    setHovering(true);
    setHoverIndex(index);
    const { left, right, top, bottom } =
      tileRef.current.getBoundingClientRect();
    const isLeftALigned = mouseLocation.x < window.innerWidth / 2;
    const isTopAligned = mouseLocation.y < window.innerHeight / 2;
    createPositionedStyle(
      left,
      right,
      top,
      bottom,
      isLeftALigned,
      isTopAligned
    );
    setHovering(true);
  };

  const debouncedMouseLeave = () => {
    setHovering(false);
  };

  return (
    <div
      className="riskTile"
      ref={tileRef}
      style={{
        backgroundColor:
          foundResults && !isCombination
            ? 'rgb(250, 250, 250)'
            : isNotFound
              ? '#e6e6e6'
              : 'rgba(89, 137, 197, 0.4)'
      }}
    >
      {foundResults &&
        riskRatedFunds.map((rrf, i) => {
          return (
            <>
              <div
                onMouseEnter={e => debouncedMouseEnter(e, i)}
                onMouseLeave={debouncedMouseLeave}
                className="innerTile"
                style={{
                  fontWeight: isCombination ? 'bold' : 'normal'
                }}
              >
                {isCombination
                  ? `${rrf.allocation * 100}% - ${rrf.name}`
                  : rrf.name}
              </div>
              {hovering && foundResults && (
                <Popup
                  timeHorizon={timeHorizon}
                  riskRatedFunds={riskRatedFunds}
                  selectedFund={riskRatedFunds[hoverIndex]}
                  style={style}
                />
              )}
            </>
          );
        })}
      {!foundResults && <div>---</div>}
    </div>
  );
};

export default RiskTile;
